import React from 'react';
import * as common from '../../../../../const/Common/CommonFunc';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import Lbl from "../../../../../components/Label/Lbl";
import {DatePicker, Empty, Icon, Spin} from "antd";
import {Button as SementicBtn, Button, Icon as SemanticIcon, Popup} from "semantic-ui-react";
import {MDBDataTable} from "mdbreact";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import NewEvent from '../CreateNewEvent/index';
import apiConfig from "../../../../../axios/axios_api_services";
import Cookies from "js-cookie";
import moment from "moment";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import success_icon from "../../../../../assets/img/sweet/success.svg";
import axios_eventtag from "../../../../../axios/axios_eventtag";
import ParticipantModal from "../Participants/index";
import * as timeutils from "../../../../../util/TimeConvertor";
import './Style.scss';
import * as innerRoutes from "../InnerRoutes/InnerRoutes";
const {RangePicker} = DatePicker;

// manage add months to given date
function addMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

// convert date to string
function dateToString(value) {
  let t = new Date(value);
  let date = ('0' + t.getDate()).slice(-2);
  let month = ('0' + (t.getMonth() + 1)).slice(-2);
  let year = t.getFullYear();
  const time = `${year}-${month}-${date}`;
  return time;
}

// handle date range
function getDateRange() {
  let date1 = addMonths(new Date(), -1).toString();
  let dateArrayx = date1.split(" ");
  let datex = dateArrayx[0] + " " + dateArrayx[1] + " " + dateArrayx[2] + " " + dateArrayx[3];
  let sdate = dateToString(datex);
  let date2 = addMonths(new Date(), 1).toString();
  let dateArrayy = date2.split(" ");
  let datey = dateArrayy[0] + " " + dateArrayy[1] + " " + dateArrayy[2] + " " + dateArrayy[3];
  let edate = dateToString(datey);
  let dateRange = [sdate, edate];
  return dateRange;
}

let delete_const = 'delete';

class App extends React.Component {
  state = {
    //open and close new event modal
    isOpenNewEvent: false,
    isOPenInvitees: false,
    //event list
    event_draft_list: [],
    event_list: [],
    event_unpublish_list: [],
    is_wait_un_publish: false,
    //start and end date
    startDate: "",
    endDate: "",
    eventFilterType: "PUBLISH",
    status: true

  };

  dateRangeHandler = (date, dateString) => {
    if (dateString[0] !== "" || dateString[1] !== "") {

      let start = new Date(timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(dateString[0])).getTime();
      // let end = new Date(dateString[1] + " 23:59:59").getTime();
      let s = timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(dateString[1] + " 23:59:59");
      let endx = new Date(s);
      endx.setMinutes(endx.getMinutes() + 330);
      let end = endx.getTime();

      this.setState({
        startDate: start,
        endDate: end,
      });
      this.getEvents(start, end);
    }
  };

  // open new event creating model
  openNewEventModal = () => {
    this.setState({isOpenNewEvent: true});
  };

  // update the event
  updateEvent = row => {
    this.props.setCurrentEventData(row);
    this.props.setCurrentSubEventsData(row.subEvent);

    if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
      if(row.has_sub_event){
        this.props.history.push(innerRoutes.cor_inner_route_event_sub_events);
      }else{
        this.props.history.push(innerRoutes.cor_inner_route_events_event);
      }
    } else {
      if(row.has_sub_event){
        this.props.history.push(innerRoutes.inner_route_event_sub_events);
      }else{
        this.props.history.push(innerRoutes.inner_route_events_event);
      }
    }

  };

  showParticipants = obj => {
    this.setState({
      isOPenInvitees: true,
      selectPartObj: obj
    });
  };


  removeEvent = (id, name) => {
    swal({
      text: "Are you sure you want to delete this event? \n If so please enter \"" + delete_const + "\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
      buttons: {
        cancel: 'Cancel',
        confirm: {
          text: "Yes",
          className: "okay-btn"
        }
      },
    }).then((result) => {
          if (result.trim() === delete_const) {
            this.deleteEvent_(id)
          } else {
            common.warningAlert("Can't delete event", 1)
          }

      });
  };

  deleteEvent_ = (id) => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_eventtag.delete(apiConfig.DELETE_CORPORATE_EVENT({eventId: id, corporateId: corporateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {

          common.warningAlert("Event deleted successfully", 0);
          // this.clearFeilds();
          let date = getDateRange();
          this.props.setCurrentEventData(null);
          this.setState({
            startDate: new Date(date[0]).getTime(),
            endDate: new Date(date[1]).getTime(),
            // event_list: this.props.test_alleventobject.eventList.event
          });
          this.getDraftEvents();
          this.getUnpublishEvents();
          this.getEvents(new Date(date[0]).getTime(), new Date(date[1]).getTime());

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteEvent_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  waitHandler = (name,condition) => {
    this.setState({
      [name]: condition
    })
  };

  getDraftEvents = () => {
    this.waitHandler("is_wait_draft", true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_DRAFT_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            event_draft_list: response.data.eventList
          });
        } else {
          this.setState({
            event_draft_list: []
          });
        }
      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.getDraftEvents();
      }
    })
      .finally(fin => {
        this.waitHandler("is_wait_draft", false);
      });
  };

  getUnpublishEvents = () => {
    this.waitHandler("is_wait_un_publish", true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_UNPUBLISH_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            event_unpublish_list: response.data.eventList
          });
        } else {
          this.setState({
            event_unpublish_list: []
          });
        }
      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.getUnpublishEvents();
      }
    })
      .finally(fin => {
        this.waitHandler("is_wait_un_publish", false);
      });
  };
  getEvents = (start, end) => {
    let start_date = this.state.startDate;
    let end_date = this.state.endDate;

    if (start && end) {
      start_date = start;
      end_date = end;
    }

    let startDate = new Date().setDate(new Date().getDate() - 30);
    let endDate = new Date().setDate(new Date().getDate());

    if (start_date !== "" && end_date !== "") {
      startDate = start_date;
      endDate = end_date;
    }

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_PUBLISHED_EVENTS({
      corporateId: corperateId,
      startDate: startDate,
      endDate: endDate
    }), {headers: headers})
      .then(async response => {
        if (response.data.success) {
          this.setState({
            event_list: response.data.eventList
          });
        } else {
          this.setState({
            event_list: []
          });
        }
      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.getEvents(start, end);
      } else {
        this.props.spinnerHandler(false)
      }
    })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  closeModalAtError = () => {
    this.setState({isOpenNewEvent: false});

    let date = getDateRange();
    this.props.setCurrentEventData(null);
    this.setState({
      startDate: new Date(date[0]).getTime(),
      endDate: new Date(date[1]).getTime(),
      // event_list: this.props.test_alleventobject.eventList.event
    });
    this.getUnpublishEvents();
    this.getEvents(new Date(date[0]).getTime(), new Date(date[1]).getTime());
  };

  componentDidMount() {

    let date = getDateRange();
    this.props.setCurrentEventData(null);
    this.setState({
      startDate: new Date(date[0]).getTime(),
      endDate: new Date(date[1]).getTime(),
      // event_list: this.props.test_alleventobject.eventList.event
    });
    this.getDraftEvents();
    this.getUnpublishEvents();
    this.getEvents(new Date(date[0]).getTime(), new Date(date[1]).getTime());
  }

  duplicateEvent = (id, name) => {
    swal({
      text: `Are you sure to duplicate the event named "${ name }"?`,
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {

        if(value==='action') {
          this.duplicateEvent_(id);
        }

      });
  }

  duplicateEvent_= id => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_eventtag.post(apiConfig.DUPLICATE_CORPORATE_EVENT({eventId: id, corporateId: corporateId})
      , null, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let content = response.data.event;
          swal({
            text: `Event duplicated successfully!`,
            icon: success_icon,
            closeOnClickOutside: false,
            buttons: {
              // cancel: 'Cancel',
              dangerMode: {
                text: "Ok",
                value: "action",
                className: "okay-btn"
              }
            },
          })
            .then((value) => {
              if(value==='action') {
                this.updateEvent(content);
              }
            });
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.duplicateEvent_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  render() {
    let columns = this.props.table_data.columns;
    let unpublish_columns = this.props.table_data.unpublish_columns;


    let row_draft = [];
    if (this.state.event_draft_list !== null) {
      this.state.event_draft_list.map((value, index) => {
        row_draft.push({
          Name: value.event_name,
          privacy: value.privacy,
          Has_sub: value.has_sub_event ? "Yes" : "No",
          action: <div>
            <Popup
              key={`view_draft_${ value.event_id }`}
              header={"View the event"}
              position='top right'
              trigger={<SementicBtn circular icon='eye' onClick={() => this.updateEvent(value)}/>}
            />

            <Popup
              key={`duplicate_draft_${ value.event_id }`}
              header={"Duplicate the event"}
              position='top right'
              trigger={
                <SementicBtn circular icon='copy' onClick={() => this.duplicateEvent(value.event_id, value.event_name)}/>
              }
            />

            <Popup
              key={`delete_draft_${ value.event_id }`}
              header={"Delete the event"}
              position='top right'
              trigger={<SementicBtn className="cus-btn" circular icon='trash alternate'
                                    onClick={() => this.removeEvent(value.event_id, value.event_name)}/>}
            />
          </div>
        });

      });
    }

    let draftData = {columns: unpublish_columns, rows: row_draft};

    let row_unp = [];
    if (this.state.event_unpublish_list !== null) {
      this.state.event_unpublish_list.map((value, index) => {
        row_unp.push({
          Name: value.event_name,
          Start_Date: value.start_time !== null ? timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.start_time + ":00") : "-",
          End_Date: value.end_time !== null ? timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.end_time + ":00") : "-",
          privacy: value.privacy,
          Has_sub: value.has_sub_event ? "Yes" : "No",
          action: <div>
            <Popup
              key={`view_unpublish_${ value.event_id }`}
              header={"View the event"}
              position='top right'
              trigger={ <SementicBtn circular icon='eye' onClick={() => this.updateEvent(value)}/>}
            />

            <Popup
              key={`participant_unpublish_${ value.event_id }`}
              header={"View event participants"}
              position='top right'
              trigger={<SementicBtn circular icon='users' onClick={() => this.showParticipants(value)}/>}
            />

            <Popup
              key={`duplicate_draft_${ value.event_id }`}
              header={"Duplicate the event"}
              position='top right'
              trigger={
                <SementicBtn circular icon='copy' onClick={() => this.duplicateEvent(value.event_id, value.event_name)}/>
              }
            />

            <Popup
              key={`delete_unpublish_${ value.event_id }`}
              header={"Delete the event"}
              position='top right'
              trigger={<SementicBtn className="cus-btn" circular icon='trash alternate'
                                    onClick={() => this.removeEvent(value.event_id, value.event_name)}/>}
            />
          </div>
        });

      });
    }

    let unpublishData = {columns: columns, rows: row_unp};

    let row = [];
    if (this.state.event_list !== null) {
      this.state.event_list.map((value, index) => {
        row.push({
          Name: value.event_name,
          Start_Date: value.start_time !== null ? timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.start_time + ":00") : "-",
          End_Date: value.end_time !== null ? timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.end_time + ":00") : "-",
          privacy: value.privacy,
          Has_sub: value.has_sub_event ? "Yes" : "No",
          action: <div>
            <Popup
              key={`view_draft_${ value.event_id }`}
              header={"View the event"}
              position='top right'
              trigger={<SementicBtn circular icon='eye' onClick={() => this.updateEvent(value)}/>}
            />

            <Popup
              key={`participant_draft_${ value.event_id }`}
              header={"View event participants"}
              position='top right'
              trigger={<SementicBtn circular icon='users' onClick={() => this.showParticipants(value)}/>}
            />

            <Popup
              key={`duplicate_draft_${ value.event_id }`}
              header={"Duplicate the event"}
              position='top right'
              trigger={
                <SementicBtn circular icon='copy' onClick={() => this.duplicateEvent(value.event_id, value.event_name)}/>
              }
            />

            <Popup
              key={`delete_draft_${ value.event_id }`}
              header={"Delete the event"}
              position='top right'
              trigger={<SementicBtn className="cus-btn" circular icon='trash alternate'
                                    onClick={() => this.removeEvent(value.event_id, value.event_name)}/>}
            />
          </div>
        });

      });
    }

    let publishData = {columns: columns, rows: row};

    //date range
    let dateRange = null;
    if (this.state.startDate !== "") {
      let startdate = this.state.startDate;
      let enddate = this.state.endDate;
      dateRange = [moment(startdate), moment(enddate)];
    } else {
      dateRange = null;
    }

    return (
      <div>
        {
          this.state.isOpenNewEvent ?
            <NewEvent hisProps={this.props} closeModal={() => this.setState({isOpenNewEvent: false})}
                      closeModalAtError={this.closeModalAtError}/> : null
        }
        {
          this.state.isOPenInvitees ? <ParticipantModal selectPartObj={this.state.selectPartObj}
                                                        closeModal={() => this.setState({isOPenInvitees: false})}/> : null
        }

        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Draft Events
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    {/*<Col lg ={12} md={12} className={'text-end'}>*/}
                    <Col lg={"12"} style={{marginBottom: '5px', marginTop: '10px', textAlign: "end"}}>
                      <Button
                        className="px-5"
                        onClick={this.openNewEventModal}
                      ><i aria-hidden="true" className="plus icon"></i>
                        New Event
                      </Button>
                      {/*</Col>*/}
                    </Col>
                  </Row>

                  <Row style={{marginTop: '20px'}}>
                    <Col lg={12} md={12}>
                      <Spin spinning={this.state.is_wait_un_publish} delay={10}
                            indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                        {
                          this.state.event_draft_list.length !== 0 ?
                            <MDBDataTable
                              searching={true}
                              displayEntries={true}
                              responsive
                              responsiveSm
                              responsiveMd
                              responsiveLg
                              responsiveXl
                              bordered
                              hover
                              data={draftData}
                            />
                            : <div className={"align-center fully-width"}>
                              <Empty description={"Records not found"} className={"empty-icon"}/>
                            </div>

                        }
                      </Spin>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Un-published Events
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <Row style={{marginTop: '20px'}}>
                    <Col lg={12} md={12}>
                      <Spin spinning={this.state.is_wait_un_publish} delay={10}
                            indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                        {
                          this.state.event_unpublish_list.length !== 0 ?
                            <MDBDataTable
                              searching={true}
                              displayEntries={true}
                              responsive
                              responsiveSm
                              responsiveMd
                              responsiveLg
                              responsiveXl
                              bordered
                              hover
                              data={unpublishData}
                            />
                            : <div className={"align-center fully-width"}>
                              <Empty description={"Records not found"} className={"empty-icon"}/>
                            </div>

                        }
                      </Spin>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Published Events
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg={6} md={6}>
                      <Col lg={12} className={"none-padding"}>
                        <Lbl>Filter Events</Lbl>
                        {/*<Lbl>Date Range</Lbl>*/}
                        <RangePicker
                          size={"mini"}
                          // disabledDate={disabledDate}
                          format="YYYY-MM-DD"
                          value={dateRange}
                          onChange={this.dateRangeHandler}
                        />
                      </Col>
                    </Col>
                  </Row>

                  <Row style={{marginTop: '20px'}}>
                    <Col lg={12} md={12}>
                      {
                        this.state.event_list.length !== 0 ?
                          <MDBDataTable
                            className={'tbl-event-all-123'}
                            searching={true}
                            displayEntries={true}
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            bordered
                            hover
                            data={publishData}
                          />
                          : <div className={"align-center fully-width"}>
                            <Empty description={"Records not found"} className={"empty-icon"}/>
                          </div>
                      }
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  table_data: state.eventReducer.Event_Table_data,
  test_alleventobject: state.eventReducer.allEventsObj,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    pgChangeHandler: (data) => dispatch(actionCreator.stepActivateionEventHandler(data)),
    setCurrentEventData: (data) => dispatch(actionCreator.setCurrentEventData(data)),
    setCurrentSubEventsData: (data) => dispatch(actionCreator.setCurrentSubEventsData(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
